var React = require('react');

function Logo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M533 301V53l134 50v50h-67l-54 38h102l19 6v154l38 14V178l-24-8 24-17V79L495 0v286l38 15zM477 79L267 0v286l210 79V178l-24-8 24-17zm-38 74h-65l-56 38h102l19 6v116l-133-50V53l133 50zM250 58V12L0 186l250 94v-38L79 178M722 306v46l250-174-250-94v38l171 64"}));
}

Logo.defaultProps = {"viewBox":"0 0 975 365"};

module.exports = Logo;

Logo.default = Logo;
